import { useState, useContext, useEffect } from "react"
import { LoaderMedium } from "./Loaders"
import userIcon from '../assets/icons/user_icon.svg'
import _ from "lodash"

// Context
import { UserContext } from "../context/userContext"
import { FirebaseContext } from "../firebase"
import { Avatar } from 'primereact/avatar';

export default function ProfilePhoto({ participant_profile_image }) {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)
  const [loading, setLoading] = useState(false)
  const [profileImageUrl, setProfileImageUrl] = useState("")

  useEffect(() => {
    setLoading(true)
    const profileImage =
      participant_profile_image !== undefined
        ? participant_profile_image
        : userCtx.participant_profile_image

    const getProfileImageUrl = async () => {
      const { getStorage, ref, getDownloadURL } = firebase.storage
      const storage = getStorage()

      if (!_.isEmpty(profileImage)) {
        const logoRef = ref(storage, profileImage)
        return await getDownloadURL(logoRef)
      }

      return null
    }

    const fetchProfilePicture = async () => {
      const imageUrl = await getProfileImageUrl()
      if (!_.isEmpty(imageUrl)) {
        setProfileImageUrl(imageUrl)
      }
      setLoading(false)
    }

    fetchProfilePicture()
  }, [
    firebase.storage,
    userCtx.participant_profile_image,
    participant_profile_image,
  ])

  if (loading) return <LoaderMedium />

  if (_.isEmpty(profileImageUrl)) {
    return <Avatar
      image={userIcon}
      shape="circle"
      style={{
        width: "24px",
        height: "24px",
      }}
    />
  }

  return (
    <Avatar
      image={profileImageUrl}
      shape="circle"
      style={{
        width: "32px",
        height: "32px",
        marginRight: "5px",
        background: "white",
      }}
    />
  )
}
